<form [formGroup]="form" class="row">
  <div class="col-12">
    <mat-form-field appearance="outline" class="col-6">
      <mat-label>4.Oficina</mat-label>
      <mat-select
        (ngModelChange)="setvaluesDirTlf()"
        formControlName="sucursal"
        placeholder="Sucursal, Agencia o Lugar donde se efectuo la operacion"
      >
        <mat-option *ngFor="let sucu of sucursal" [value]="sucu">
          {{ sucu }}
        </mat-option>
      </mat-select>
      <!-- <input
        formControlName="sucursal"
        placeholder="Sucursal, Agencia o Lugar donde se efectuo la operacion"
        matInput
      /> -->
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-6">
      <mat-label>5.Teléfonos de la Sucursal, Agencia o Lugar</mat-label>
      <input formControlName="telefono" matInput />
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-6">
      <mat-label>6.Dirección de la Sucursal, Agencia o Lugar</mat-label>
      <input formControlName="direccion" matInput />
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-6">
      <mat-label>Región de la alerta *</mat-label>
      <mat-select formControlName="region_de_la_alerta" placeholder="Region 1">
        <mat-option *ngFor="let region of regions" [value]="region">
          {{ region }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-4">
      <mat-label>7.Estado</mat-label>
      <!-- <input formControlName="estado" matInput /> -->
      <mat-select
        (ngModelChange)="changeEstado($event)"
        formControlName="estado"
        placeholder="Estado"
      >
        <mat-option *ngFor="let estad of est" [value]="estad">
          {{ estad }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-4">
      <mat-label>8.Municipio</mat-label>
      <!-- <input formControlName="municipio" matInput /> -->
      <mat-select
        (ngModelChange)="changeMunicipio($event)"
        [disabled]="!mun"
        formControlName="municipio"
        placeholder="Municipio"
      >
        <mat-option *ngFor="let muni of mun" [value]="muni">
          {{ muni }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-4">
      <mat-label>9.Parroquia</mat-label>
      <!-- <input formControlName="parroquia" matInput /> -->
      <mat-select
        [disabled]="!parr"
        formControlName="parroquia"
        placeholder="Parroquia"
      >
        <mat-option *ngFor="let parro of parr" [value]="parro">
          {{ parro }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</form>
